import React from "react";
import PropTypes from "prop-types";
import "./PageLayout.css";

/**
 * Reusable page layout component with header
 * Used across My Orders, Profile, Promotions, etc.
 */
const PageLayout = ({ 
  icon: Icon, 
  title, 
  subtitle, 
  children,
  headerClassName = "",
  summary = null
}) => {
  return (
    <div className="page-layout-container">
      {/* Page Header */}
      <div className={`page-layout-header ${headerClassName}`}>
        <div className="page-layout-header-left">
          <div className="page-layout-header-content">
            {Icon && <Icon className="page-layout-header-icon" />}
            <h2 className="page-layout-header-title">{title}</h2>
          </div>
          {subtitle && (
            <p className="page-layout-header-subtitle">{subtitle}</p>
          )}
        </div>
        
        {/* Summary badges on the right */}
        {summary && (
          <div className="page-layout-header-summary">
            {summary}
          </div>
        )}
      </div>

      {/* Page Content */}
      <div className="page-layout-content">
        {children}
      </div>
    </div>
  );
};

PageLayout.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  headerClassName: PropTypes.string,
  summary: PropTypes.node,
};

export default PageLayout;
